import React from "react"
import { Translation } from "react-i18next";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { format, parseISO } from "date-fns";

export default class OrderCard extends React.Component {

    renderTotal = (item) => {
        let result;
        if (item.operatorCart && item.operatorCart.totalToPay) {
            result = `${item.operatorCart.totalToPay.toFixed(2)} \u20AC`
        } else {
            result = `${item.cart.totalToPay.toFixed(2)} \u20AC`
        }
        return result;
    }

    render() {
        const { item, selectOrder, currentOrder } = this.props;
        return (
            <Translation>
                {t =>
                    <div className={`card w-100 mb-3 ${item.id === currentOrder.id ? "card-selected" : ""}`} onClick={() => { selectOrder(item.id, item.status) }}>
                        <div className="row no-gutters">
                            <div className="col-md-12">
                                <div className="card-body">
                                    <Row>
                                        <Col sm={5}>
                                            <h5 className="card-title title">{item.cart.title}</h5>
                                        </Col>

                                        <Col sm={7}>
                                            <h5 className="card-title title">
                                                {t("order.status")}:
                                                <span className={`ml-1 order-status-${item.status}`}>
                                                    {t(`order.status.${item.status}`)}
                                                </span>
                                            </h5>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={5}>
                                            <p className="card-text subtitle">
                                                {t("total")}: {this.renderTotal(item)}
                                            </p>
                                        </Col>
                                        <Col sm={7}>
                                            <p className="card-text-muted">
                                                {t("deliveryDate")}:    {item.deliveryDate && format(parseISO(item.deliveryDate), "dd/MM/yyyy")}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </Translation>
        );
    }
}